export default {
  'SET_AUTOMATIONS'(state, data) {
    state.automations = data;
  },
  'ADD_AUTOMATION'(state, data) {
    state.automations.push(data);
  },
  'REPLACE_AUTOMATION'(state, payload) {
    const {id, data} = payload;
    state.automations = state.automations.map(item => {
      if (parseInt(item.id) !== parseInt(id)) {
        return item;
      }

      return data;
    });
  },
  'DELETE_AUTOMATION'(state, id) {
    state.automations = state.automations.filter(item => {
      return parseInt(item.id) !== parseInt(id);
    });
  },
  'SET_EVENT_EVALUATION_TEMPLATES'(state, data) {
    state.eventEvaluationTemplates = data;
  },
  'SET_CONDITION_OPERATORS'(state, data) {
    state.conditionOperators = data;
  },
  'SET_SCHEDULE_REPEAT_TEMPLATES'(state, data) {
    state.scheduleRepeatTemplates = data;
  }
};